// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Who built a translation.
 */
export enum BuildHost {
  Unspecified = 0,
  Vts = 1,
  LiftCloud = 2,
  Browser = 3,
  Cli = 4,
}
